export function joinPath(parts: (string | undefined)[], sep: string = '/') {
  const separator = sep || '/';
  const replace = new RegExp('\\b' + separator + '{1,}', 'g');
  return parts
    .map(p => p || '')
    .join(separator)
    .replace(replace, separator)
    .replace(/^\/{1,}/, '/');
}
